var _rect, _path, _path2, _rect2, _rect3, _rect4, _circle, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSetPin = function SvgSetPin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 8,
    fill: "#FDEDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20C19 17.2386 21.2386 15 24 15H47C49.7614 15 52 17.2386 52 20V71.8966H19V20Z",
    fill: "#EDF2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1379 21.1379C20.1379 18.3765 22.3765 16.1379 25.1379 16.1379H45.8621C48.6235 16.1379 50.8621 18.3765 50.8621 21.1379V71.8966H20.1379V21.1379Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5518,
    y: 35.4827,
    width: 23.8966,
    height: 4.55172,
    fill: "#E2E9F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5518,
    y: 42.3103,
    width: 23.8966,
    height: 4.55172,
    fill: "#E2E9F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5518,
    y: 55.9656,
    width: 23.8966,
    height: 4.55172,
    fill: "#F7BAA6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 19,
    r: 12,
    fill: "#EE6F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9899 11.3333C52.0357 11.3333 53.6819 12.9431 53.6819 14.9306V15.9528C54.8301 16.3112 55.6667 17.3507 55.6667 18.5922V21.8835C55.6667 23.4204 54.3925 24.6666 52.8215 24.6666H47.1792C45.6076 24.6666 44.3334 23.4204 44.3334 21.8835V18.5922C44.3334 17.3507 45.1707 16.3112 46.3182 15.9528V14.9306C46.325 12.9431 47.9712 11.3333 49.9899 11.3333ZM49.9967 18.9228C49.6715 18.9228 49.4073 19.1811 49.4073 19.4991V20.9699C49.4073 21.2945 49.6715 21.5529 49.9967 21.5529C50.3286 21.5529 50.5928 21.2945 50.5928 20.9699V19.4991C50.5928 19.1811 50.3286 18.9228 49.9967 18.9228ZM50.0034 12.4926C48.6283 12.4926 47.5105 13.5791 47.5037 14.9173V15.8091H52.4964V14.9306C52.4964 13.5857 51.3786 12.4926 50.0034 12.4926Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSetPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/setPin.c26ab252.svg";
export { ForwardRef as ReactComponent };